import { Box, Theme } from "@radix-ui/themes";
import React, { JSX } from "react";

import { brand } from "../constants/brandVariables/brandVariables";

interface ThemeProviderProps {
  children: React.ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps): JSX.Element {
  return (
    <Theme {...brand.theme}>
      <Box className={`theme-${brand.themeId} ${brand.gameStyle}`}>
        {children}
      </Box>
    </Theme>
  );
}
